export function convertToEuropeanFormat(dateString: string) {
    if (dateString) {
        const dateObj = new Date(dateString);
        return dateObj.toLocaleString("en-GB").slice(0, 10);
    } else {
        return null
    }
}

export const formatDateTimeForInput = (d: any) => {
    if (d) {
        d = d.slice(0, 10);
        // if (d.length === 10) {
        //     d += " 00:00:00";
        // }
        return d;
    } else {
        return d;
    }
};
